import axios from "axios";

const { createSlice, createAsyncThunk } = require('@reduxjs/toolkit');

export const STATUSES = Object.freeze({
    IDLE: 'idle',
    ERROR: 'error',
    LOADING: 'loading',
});

const userSlice = createSlice({
    name: 'user',
    initialState: {
        data: {},
        status: STATUSES.IDLE,
    },
    reducers: {
        // setProducts(state, action) {
        //     state.data = action.payload;
        // },
        // setStatus(state, action) {
        //     state.status = action.payload;
        // },
    },
    extraReducers: (builder) => {
        builder
            .addCase(LoginUser.pending, (state, action) => {
                state.status = STATUSES.LOADING;
            })
            .addCase(LoginUser.fulfilled, (state, action) => {
                console.log(action, "action.payload")
                state.data = action.payload;
                state.status = STATUSES.IDLE;
            })
            .addCase(LoginUser.rejected, (state, action) => {
                state.status = STATUSES.ERROR;
            });
    },
});

export const { setUser, setStatus } = userSlice.actions;
export default userSlice.reducer;

// Thunks
export const LoginUser = createAsyncThunk('user/store', async (data) => {
    return axios.get("/sanctum/csrf-cookie").then(async (response) => {
        const result = await axios.post(`/api/login`, data);
        console.log(result.data, "reducer")
        return result.data;

    });

});

// export function fetchProducts() {
//     return async function fetchProductThunk(dispatch, getState) {
//         dispatch(setStatus(STATUSES.LOADING));
//         try {
//             const res = await fetch('https://fakestoreapi.com/products');
//             const data = await res.json();
//             dispatch(setProducts(data));
//             dispatch(setStatus(STATUSES.IDLE));
//         } catch (err) {
//             console.log(err);
//             dispatch(setStatus(STATUSES.ERROR));
//         }
//     };
// }